module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc29-c465048e10c0a5e84760ca69609b57a7.jpg";